import { render } from "./CustomFinishing.vue?vue&type=template&id=04dc8ff7&scoped=true"
import script from "./CustomFinishing.vue?vue&type=script&lang=js"
export * from "./CustomFinishing.vue?vue&type=script&lang=js"

import "./CustomFinishing.vue?vue&type=style&index=0&id=04dc8ff7&lang=scss&scoped=true"

import exportComponent from "/Users/mateomateus/Documents/Rabinovici/hp-blueprint-presentation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04dc8ff7"]])

export default __exports__